/**
 * TanStack Query hooks for `igaming-cross-brand-player-de-duplication`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingCrossBrandPlayerDeDuplicationQueryKeys,
	type CreateIgamingCrossBrandPlayerDeDuplicationBody,
	type ListIgamingCrossBrandPlayerDeDuplicationResponse,
	type IgamingCrossBrandPlayerDeDuplicationRow,
} from "./api";

export function useIgamingCrossBrandPlayerDeDuplicationList(): UseQueryResult<ListIgamingCrossBrandPlayerDeDuplicationResponse, Error> {
	return useQuery({
		queryKey: igamingCrossBrandPlayerDeDuplicationQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingCrossBrandPlayerDeDuplicationCreate(): UseMutationResult<IgamingCrossBrandPlayerDeDuplicationRow, Error, CreateIgamingCrossBrandPlayerDeDuplicationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCrossBrandPlayerDeDuplicationQueryKeys.all });
		},
	});
}

export function useIgamingCrossBrandPlayerDeDuplicationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingCrossBrandPlayerDeDuplicationQueryKeys.all });
		},
	});
}
